import emptyActiveCarrierFilterModel from './empty-filters';

export default emptyActiveCarrierFilterModel;
